import { useParams, useSearchParams } from 'react-router-dom';
import { BOOKING_PAGE, BookingPageView } from '@elva/ui';
import type { BookingStep, InsuranceState } from '@elva/ui';

const INS_STATES: InsuranceState[] = ['innetwork', 'outofnetwork', 'checking', 'found', 'notfound', 'timeout'];

/**
 * The public booking page (spec 50 §1) — `/book/:code`, rendered outside the app
 * shell so there is no staff nav. Branded in the practice's colour.
 *
 * Demo flags on the address let the states be seen without a backend:
 * `?step=1…6`, `?onfile=1`, `?ins=…`, `?booked=1`, `?fee=0`, `?closed=1`.
 */
export function BookingPagePublicPage() {
  const { code } = useParams<{ code: string }>();
  const [params] = useSearchParams();

  const stepParam = Number(params.get('step'));
  const initialStep: BookingStep = stepParam >= 1 && stepParam <= 6 ? (stepParam as BookingStep) : 1;
  const insParam = params.get('ins') ?? '';
  const insState = (INS_STATES as string[]).includes(insParam) ? (insParam as InsuranceState) : undefined;

  return (
    <BookingPageView
      config={{ ...BOOKING_PAGE, slug: code ?? BOOKING_PAGE.slug }}
      initialStep={initialStep}
      onFile={params.get('onfile') === '1'}
      insState={insState}
      booked={params.get('booked') === '1'}
      noFee={params.get('fee') === '0'}
      closed={params.get('closed') === '1'}
    />
  );
}
